import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles/index';
import red from '@material-ui/core/colors/red';
import Transition from './Transition';
import Zoom from '@material-ui/core/Zoom';
import CircularProgress from '@material-ui/core/CircularProgress';
import GreenChecked from '../../images/icons/greenChecked.svg';

const styles = (theme) => ({
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 50px 20px 50px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		width: '60%',
		maxWidth: '90%',
	},
	question: {
		margin: 20,
		padding: '20px 20px 10px 20px',
		border: `1px solid #eee`,
		backgroundColor: '#f9f9f9',
		fontSize: 18,
		textAlign: 'left',
	},
	actions: {
		padding: 10,
	},
	warningButton: {
		borderRadius: 100,
		color: theme.palette.getContrastText(red[500]),
		backgroundColor: red[500],
		'&:hover': {
			backgroundColor: red[700],
		},
	},
	greenCheckedIcon: {
		display: 'inline-block',
		width: 33,
		height: 33,
		backgroundImage: `url('${GreenChecked}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
		marginLeft: 5,
	},
	isSaving: {
		marginLeft: 20,
		fontSize: 16,
		color: '#1565C0',
	},
	savingSuccessful: {
		marginLeft: 20,
		fontSize: 16,
		color: '#2E7D32',
	},
});

class GenericConfirmDeletionDialog extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			isSaving: false,
			savingStatus: undefined,
			savingSuccessful: false,
		};
	}

	handleClose = () => {
		this.setState(
			{
				isSaving: false,
				savingStatus: undefined,
				savingSuccessful: false,
			},
			this.props.onClose
		);
	};

	handleDelete = () => {
		const { showErrors, apiDeleteFunction } = this.props;

		this.setState({
			isSaving: true,
		});

		apiDeleteFunction({
			callback: (err) => {
				if (err) {
					this.setState({
						isSaving: false,
					});
					return showErrors([err]);
				}

				_.delay(() => {
					this.setState({
						isSaving: false,
						savingSuccessful: true,
					});
				}, 500);
			},
		});
	};

	render() {
		const { classes, open, title } = this.props;
		const { isSaving, savingSuccessful } = this.state;

		return (
			<Dialog
				maxWidth="sm"
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{
					paper: classes.dialogPaper,
				}}
			>
				<DialogTitle>{title || 'Confirm Delete'}</DialogTitle>

				<div className={classes.question}>{this.props.questionText}</div>

				<DialogActions>
					<div>
						<Zoom
							in={isSaving}
							style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
							mountOnEnter
							unmountOnExit
						>
							<div className={classes.isSaving}>
								<CircularProgress style={{ verticalAlign: 'middle' }} />
								<span style={{ paddingLeft: 10 }}>Saving...</span>
							</div>
						</Zoom>

						<Zoom
							in={savingSuccessful}
							style={{ transitionDelay: savingSuccessful ? '250ms' : '0ms' }}
						>
							<div className={classes.savingSuccessful}>
								<div className={classes.greenCheckedIcon} />
								<span style={{ paddingLeft: 10 }}>Save Successful.</span>
							</div>
						</Zoom>
					</div>

					<div className={classes.actions}>
						<Button onClick={this.handleClose}>Close</Button>
						<Button
							variant="contained"
							onClick={this.handleDelete}
							className={classes.warningButton}
							disabled={isSaving || savingSuccessful}
						>
							Yes, delete item
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}
}

GenericConfirmDeletionDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	apiDeleteFunction: PropTypes.func.isRequired,
	questionText: PropTypes.string.isRequired,
	title: PropTypes.string,

	//- Could be either
	showErrors: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), withMobileDialog()])(GenericConfirmDeletionDialog);
